<template>
  <FlexCol gap-4>
    <Grid gap-3 cols-3 class="pb-3 border-b">
      <div>
        <div class="text-gray-500 text-sm">Grupo</div>
        <div>{{ item?.serviceGroup ?? '-' }}</div>
      </div>
      <div>
        <div class="text-gray-500 text-sm">Setor</div>
        <div>{{ item?.sectorName ?? '-' }}</div>
      </div>
      <div>
        <div class="text-gray-500 text-sm">Tipo de Equipe</div>
        <div>{{ item?.teamType ?? '-' }}</div>
      </div>
    </Grid>

    <Accordion title="Serviços Secundários">
      <TableFull :headers="headersSecondary" :items="secondaryItems" v-model="tableSecondary" offline />
    </Accordion>

    <Accordion title="MOS Serviço Relacionados">
      <FlexCol gap-3>
        <div class="text-lg">Áreas Comuns</div>
        <TableFull :headers="headersMos" :items="mosRelatedCommon" v-model="tableMosRelatedCommon" offline />

        <div class="text-lg">Áreas de Complexidade</div>
        <TableFull :headers="headersMos" :items="mosRelatedComplexity" v-model="tableMosRelatedComplexity" offline />
      </FlexCol>
    </Accordion>

    <Accordion title="MOS de Deslocamentos">
      <FlexCol gap-3>
        <div class="text-lg">Áreas Comuns</div>
        <TableFull :headers="headersMovementMos" :items="mosMovementCommon" v-model="tableMosMovementCommon" offline />

        <div class="text-lg">Áreas de Complexidade</div>
        <TableFull :headers="headersMovementMos" :items="mosMovementComplexity" v-model="tableMosMovementComplexity" offline />
      </FlexCol>
    </Accordion>
  </FlexCol>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { get } from '@/crud'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const headersSecondary = ref([
  { title: 'Código', field: 'externalCode' },
  { title: 'Descrição', field: 'name' },
  { title: 'Justificativa', field: 'glosa' },
])

const headersMos = ref([
  { title: 'Código', field: 'idMos' },
  { title: 'Descrição', field: 'title' },
  { title: 'Pontos', field: 'points' },
])

const headersMovementMos = ref([
  { title: 'Distrito', field: 'district' },
  { title: 'Código', field: 'idMos' },
  { title: 'Descrição', field: 'title' },
  { title: 'Pontos', field: 'points' },
])

const tableSecondary = ref({ page: 1, total: 0, limit: 50, pages: 0, order: [] })
const tableMosRelatedCommon = ref({ page: 1, total: 0, limit: 50, pages: 0, order: [] })
const tableMosRelatedComplexity = ref({ page: 1, total: 0, limit: 50, pages: 0, order: [] })
const tableMosMovementCommon = ref({ page: 1, total: 0, limit: 50, pages: 0, order: [] })
const tableMosMovementComplexity = ref({ page: 1, total: 0, limit: 50, pages: 0, order: [] })

const secondaryItems = ref([])
const mosRelatedCommon = ref([])
const mosRelatedComplexity = ref([])
const mosMovementCommon = ref([])
const mosMovementComplexity = ref([])

const normalizeMovementRows = (rows = []) => {
  return rows.map((row) => ({ ...row, district: row.district ?? '0000' }))
}

const loadSecondary = async (idService) => {
  const response = await get(`service/${idService}/secondary`)
  secondaryItems.value = response?.error ? [] : response.data || []
}

const loadMos = async (idService, movementFlag, complexityAreaFlag) => {
  const response = await get(`service/${idService}/mos`, {
    params: { movementFlag, complexityAreaFlag },
  })
  if (response?.error) {
    return []
  }
  return response.data || []
}

const loadAll = async () => {
  const idService = Number(props.item?.id || 0)
  if (!idService) {
    secondaryItems.value = []
    mosRelatedCommon.value = []
    mosRelatedComplexity.value = []
    mosMovementCommon.value = []
    mosMovementComplexity.value = []
    return
  }

  await loadSecondary(idService)
  mosRelatedCommon.value = await loadMos(idService, 0, 0)
  mosRelatedComplexity.value = await loadMos(idService, 0, 1)
  mosMovementCommon.value = normalizeMovementRows(await loadMos(idService, 1, 0))
  mosMovementComplexity.value = normalizeMovementRows(await loadMos(idService, 1, 1))
}

watch(
  () => props.item?.id,
  async () => {
    await loadAll()
  },
  { immediate: true },
)

onMounted(async () => {
  await loadAll()
})
</script>
